module.exports = __webpack_public_path__ + "static/media/landelijk.1652e270.jpg";